module.exports = __webpack_public_path__ + "img/bubblhub-symbol.421c308f.png";